module.exports = __webpack_public_path__ + "img/logo-konservasi.6b827296.png";